module.exports = __webpack_public_path__ + "static/img/22.3a3d99c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/22.png
// module id = aiDn
// module chunks = 0